<template>
  <div id="recentdoc">
    <div class="top">
      <el-form inline class="form" size="small" style="float: right">
        <el-form-item>
          <el-input v-model="keyword" size="small" placeholder="请输入文件名称、项目名称" style="width:240px" @input="querlist">
            <i slot="suffix" class="el-icon-search el-input__icon" />
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <el-table ref="multipleTable1" :data="tableData1" border tooltip-effect="dark" column-key="fileName" empty-text=""
      highlight-current-row height="100%" class="multipleTable1">
      <template slot="empty">
        <img :src="zanwu" alt="" />
        <p style="font-size:16px;">暂无数据</p>
      </template>
      <el-table-column prop="fileName" label="文件名称" sortable align="left" header-align="center">
        <template slot-scope="{ row }">
          <div style="display:flex;align-items: center" class="colCheck">
            <img :src="className(row)" class="tableicon"
              style="flex-shrink:0;margin-right:6px;width:24px;height:24px" />
            <el-link type="primary" @click="clickFolderFile(row)">
              <span class="tabLinkSpan" :title="row.fileName">{{ row.fileName }}</span>
            </el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="prjName" label="项目名称" align="left" width="320" header-align="center" sortable></el-table-column>
      <el-table-column show-overflow-tooltip prop="readableFileSize" label="文件大小" width="120" align="center" sortable></el-table-column>
      <el-table-column show-overflow-tooltip prop="viewTime" label="访问时间" width="180" align="center" sortable></el-table-column>
      <el-table-column v-slot="{row}" prop="folderPath" label="文件路径" width="180" align="left" header-align="center" sortable>
        <el-link v-if="row.folderPath!='-'" type="primary" @click="clickJump(row)">
          <span class="tabLinkSpan" :title="row.folderPath">{{ row.folderPath }}</span>
        </el-link>
        <span v-else class="tabLinkSpan" :title="row.folderPath">{{ row.folderPath }}</span>
      </el-table-column>
    </el-table>
    <div style="text-align:right" class="pagination">
      <page :page="page" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></page>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { filePreviewV1, recentdoctableRowIcon } from "@/CommonDP/utils/docPublic";
import page from "@/CommonDP/components/paging";
import fileService from "@/CommonDP/service/file-service";
import docService from "@/CommonDP/service/doc-service";
import flowService from "@/CommonDP/service/flow-service";

export default {
  name: "Recentdoc",
  components: { page },
  data() {
    return {
      tableData1: [],
      page: {
        totalCount: 0,
        pageNum: 1,
        pageSize: 20
      },
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      keyword: ''
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      userInfo: state => state.user.userInfo
    })
  },
  created() {
    this.querlist();
  },
  methods: {
    async querlist() {
      // 查询表格数据
      const {
        page: { pageNum, pageSize },
        enterpriseId,
        keyword
      } = this;
      const res = await fileService.getUserRecentViewFiles(pageNum, pageSize, enterpriseId, keyword);
      res.data.forEach(ele => {
        if (ele.prjId === 'EnterpriseDeptDoc' || ele.prjId === 'EnterpriseDoc' || ele.prjId === 'MyDoc') {
          ele.prjName = '知识库';
        }
        if (ele.folderPath === 'Hide') {
          ele.folderPath = '-';
        }
      });
      this.tableData1 = res.data;
      this.page.totalCount = res.totalCount;
    },
    handleSizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.querlist();
    },
    // 分页
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.querlist();
    },
    clickFolderFile(row) {
      const { status, fileId, fileVersion: versionId = 1, parentId, fileType } = row;
      const data = { status, fileId, versionId, parentId, fileType };
      filePreviewV1(data, this.tableData1);
      this.querlist();
    },
    className(row) {
      return recentdoctableRowIcon(row);
    },
    async clickJump(row) {
      const { prjId, fileId, oldId } = row;
      if (prjId === "MyDoc") {
        // 我的文档
        try {
          const result = await docService.navbar(0, fileId);
          if (result.result === "0") {
            this.$store.dispatch("perFileUpdateNavDan", result.data);
            this.$store.dispatch("perFileUpdateTreeNodeDan", row);
            this.$router.push({ name: "mydoc" });
          }
        } catch (e) {
          console.log(e);
        }
      } else if (prjId === "EnterpriseDoc" && oldId === 'E0000000000002') {
        // console.log('公共资料');
        try {
          const result = await docService.navbar(0, fileId);
          if (result.result === "0") {
            this.$store.dispatch("perFileUpdateNavFen", result.data);
            this.$store.dispatch("perFileUpdateTreeNodeFen", row);
            this.$router.push({ name: "publicinformation" });
          }
        } catch (e) {
          console.log(e);
        }
      } else if (prjId === "EnterpriseDoc" && oldId === 'E0000000000001') {
        try {
          const result = await docService.navbar(0, fileId);
          if (result.result === "0") {
            this.$store.dispatch("perFileUpdateNavFen", result.data);
            this.$store.dispatch("perFileUpdateTreeNodeFen", row);
            this.$router.push({ name: "sharinformation" });
          }
        } catch (e) {
          console.log(e);
        }
      } else if (prjId === "EnterpriseDeptDoc") {
        try {
          const result = await docService.navbarEnterpriseDept(0, fileId);
          if (result.result === "0") {
            this.$store.dispatch("perFileUpdateNavDan", result.data);
            this.$store.dispatch("perFileUpdateTreeNodeDan", row);
            const names = result.data[0].folderId;
            this.$router.push({ name: names });
          }
        } catch (e) {
          console.log(e);
        }
      } else {
        const result = await flowService.getProjectUsers(prjId);
        const users = result.data || [];
        const exist = users.filter(item => item.userId === this.userInfo.userId);
        if (!exist || !exist.length) {
          this.$message.warning("当前用户不在该项目内");
          return;
        }
        const res = await flowService.viewList(prjId);
        this.$store.dispatch("updatePrj", res.data);
        const { data } = await docService.navbar(0, fileId);
        const paths = data || [];
        this.$store.dispatch("XtDesignUpdateNav", paths);
        this.$router.push({
          path: "/project-XtDesign"
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#recentdoc {
  padding: var(--big-space) var(--big-space) 0;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  .tableicon {
    image-rendering: -moz-crisp-edges;
    image-rendering: -o-crisp-edges;
    image-rendering: -webkit-optimize-contrast;
    -ms-interpolation-mode: nearest-neighbor;
  }
  .multipleTable1{
    height: 1px;
    flex-grow: 1;
  }
  .pagination {
    padding: var(--middle-space) 0;
    /deep/ .number {
      border: 1px solid #D9D9D9;
      background: none;
    }

    /deep/ .el-pager li.btn-quicknext, .el-pager li.btn-quickprev {
      border: 1px solid #D9D9D9;
      background: none;
    }

    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
      border: 1px solid #1890FF;
      color: #1890FF;
      background: none;
    }

    /deep/ .btn-prev {
      border: 1px solid #D9D9D9;
      background: none;
    }

    /deep/ .btn-next {
      border: 1px solid #D9D9D9;
      background: none;
    }
  }
}
</style>
